export const ROOT_MODULE_NAME = 'axp-consumer-travel-root';
export const MODULE_NAME = 'travel-personalized-marketing-articles';
export const ADS_MODULE_NAME = 'axp-personalized-marketing';

export const ONE_DATA_FUNCTION_NAME = 'ReadGetPersonalizedMarketingArticles.v1';

// ClientIds
export const HOMEPAGE_CLIENT = 'homepage';
export const LUXURY_HOTELS_CLIENT = "luxury-hotels";
export const SUMMARY_CLIENT = "summary";

export const clients = new Set([
  HOMEPAGE_CLIENT,
  LUXURY_HOTELS_CLIENT,
  SUMMARY_CLIENT,
]);

// PlacementIds
export const GET_INSPIRED_PLACEMENT = "get-inspired";
export const FOR_YOU_PLACEMENT = "for-you";

export const placements = new Set([
  FOR_YOU_PLACEMENT,
  GET_INSPIRED_PLACEMENT,
]);

// Experiments
export const MOSAIC_GET_INSPIRED_EXPERIMENT = 'prebooking_home_mosaic_get_inspired_user';
